/* eslint-disable no-mixed-operators */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Content from "../../../Components/Dashboard/Content/Content";
import Loader from "../../../Utils/Loader";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Pencil, Trash2 } from "lucide-react";
import {
  GET_ALL_CLIENTS,
  GO_TO_DASHBOARDS,
  UPDATE_USER_ACTIVE_STATUS,
} from "../../../ReduxStore/Slice/Admin/AdminSlice";
// import { Link, useNavigate, useLocation } from "react-router-dom";

import * as Config from "../../../Utils/Config";
import { DELETE_USER_SERVICES } from "../../../ReduxStore/Slice/Subadmin/userSlice";
import { useDispatch } from "react-redux";
import { fDateTimeSuffix } from "../../../Utils/Date_formet";
import { maskEmail, maskNumber } from "../../../Utils/HideWIthStart";
import { Get_Sub_Admin_Permissions } from "../../../ReduxStore/Slice/Subadmin/Subadminslice";
import toast from "react-hot-toast";
import ToastButton from "../../../Components/ExtraComponents/Alert_Toast";
import Table from "../../../Components/ExtraComponents/Tables/FullDataTable";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import Swal from "sweetalert2";



let BrokerArry = [
  {
    label: "CoinDCX",
    value: "1",
  },
  {
    label: "Delta Exchange",
    value: "2",
  },
  {
    label: "Binance",
    value: "3",
  },
  {
    label: "CoinSwitch",
    value: "5",
  }
];

const AllClients = () => {

  const location = useLocation();

  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState("");
  const [ClientStatus, setClientStatus] = useState("null");
  const [PanelStatus, setPanelStatus] = useState("2");
  const dispatch = useDispatch();
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const gotodashboard = JSON.parse(localStorage.getItem("user_details_goTo"));
  const isgotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const [refresh, setrefresh] = useState(false);
  const [getPermissions, setGetPermissions] = useState([]);
  const [getAllClients, setAllClients] = useState({ loading: true, data: [] });

  const [getPage, setPage] = useState(1);
  const [getSizePerPage, setSizePerPage] = useState(10);
  const [total1, setTotal] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const params = new URLSearchParams(location.search);
  const [isLoading, setIsLoading] = useState(true);



  const handleSearch = () => {
    setSearchQuery(searchInput);
  };

  useEffect(() => {
    GetSubAdminPermisson();
  }, []);

  useEffect(() => {
    if (refresh) {
      setClientStatus("");
      setPanelStatus("");
      setSearchQuery("");
      setSearchInput("");
      setPage(1);
      setSizePerPage(10);
      // GetClientsApi();
      setrefresh(false);
    } else {
      GetClientsApi();
    }
  }, [refresh, searchInput, ClientStatus, PanelStatus, getPage, getSizePerPage, searchQuery]);

  // Detect ?filter=active from URL and auto-set filter
  // useEffect(() => {
  //   const filter = params.get("filter");
  //   if (filter === "active") {
  //     setPanelStatus("1"); 
  //     setClientStatus("2"); 
  //   } else if (filter === "inactive") {
  //     setPanelStatus("0");
  //     setClientStatus("null");
  //   } else {
  //     setPanelStatus("2");
  //     setClientStatus("null");
  //   }
  // }, [location.search]);

  // DELETE USET FUNCTION TO DELETE ALL SERVICES
  const Delete_user = async (id) => {
    var req1 = {
      id: id,
    };
    if (window.confirm("Do you want to delete this User ?")) {
      await dispatch(DELETE_USER_SERVICES(req1))
        .unwrap()
        .then((response) => {
          if (response.status) {
            setrefresh(!refresh);
          }
        });
    }
  };




  const GetClientsApi = async () => {
    setIsLoading(true);
    var req1 = {
      Find_Role: isgotodashboard ? gotodashboard?.Role : user_details?.Role,
      user_ID: isgotodashboard ? gotodashboard?.user_id : user_details?.user_id,
      page: getPage,
      limit: getSizePerPage,
      ClientStatus: ClientStatus,
      PanelStatus: PanelStatus,
      searchQuery: searchQuery,
      search: searchInput,
    };

    await dispatch(GET_ALL_CLIENTS(req1))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setTotal(response?.pagination?.total);

          const filter = params.get("filter");
          let filteredData = response.data;

          // 🟢 Apply URL-based filter
          if (filter === "active") {
            filteredData = response.data.filter((client) => {
              return new Date(client.EndDate) > new Date(); // Active clients only
            });
          } else if (filter === "inactive") {
            filteredData = response.data.filter((client) => {
              return new Date(client.EndDate) <= new Date(); // Expired clients only
            });
          }

          setAllClients({
            loading: false,
            data: filteredData,
          });
        } else {
          setAllClients({
            loading: false,
            data: response.data,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching clients:", error);
        setAllClients({
          loading: false,
          data: [],
        });
      }
      ).finally(() => {
        setIsLoading(false);
      });

  };



  const GetSubAdminPermisson = async () => {
    await dispatch(Get_Sub_Admin_Permissions({ id: user_details.user_id }))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setGetPermissions(response.data[0]);
        }
      });
  };

  // GO TO DASHBOARD
  const goToDashboard = async (asyncid, email, row) => {
    // if (row.AppLoginStatus === "0" && row.WebLoginStatus === "0") {
    //   return;
    // }

    let req = {
      Email: email,
    };
    await dispatch(GO_TO_DASHBOARDS(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          localStorage.setItem("route", "/subadmin/clients");
          localStorage.setItem("gotodashboard", JSON.stringify(true));
          localStorage.setItem(
            "user_details_goTo",
            JSON.stringify(response.data)
          );
          localStorage.setItem(
            "user_role_goTo",
            JSON.stringify(response.data.Role)
          );
          navigate("/client/dashboard");
        }
      });
  };
  const showLicenceName = (value1, licence_type) => {
    let value = parseInt(value1);

    if (licence_type === "0") {
      return "2 Days";
    } else if (licence_type === "1") {
      return "Demo";
    } else {
      return value;
    }
  };
  // ACTIVE USER TO API
  const activeUser = async (e, data) => {
    const originalStatus = e.target.checked; // save checkbox state

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to change the status for this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    });

    if (result.isConfirmed) {
      const req = {
        id: data._id,
        user_active_status: originalStatus ? "1" : "0",
      };

      try {
        const response = await dispatch(UPDATE_USER_ACTIVE_STATUS(req)).unwrap();
        if (response.status) {
          toast.success(response.msg);
          setTimeout(() => {
            setrefresh(!refresh);
          }, 500);
        } else {
          toast.error(response.msg);
          e.target.checked = !originalStatus; // revert checkbox if API fails
        }
      } catch (err) {
        toast.error("Something went wrong!");
        e.target.checked = !originalStatus; // revert checkbox on error
      }
    } else {
      // revert checkbox if user cancels
      e.target.checked = !originalStatus;
      setrefresh(!refresh); // optional, if you want to refresh UI
    }
  };


  const showBrokerName = (value1, licence_type) => {
    if (licence_type === "1") {
      return "Demo";

    }


    const foundBroker = BrokerArry?.find(
      (data) => parseInt(data.value) == parseInt(value1)
    );

    return foundBroker?.label ?? "-";
  };


  const columns = [
    {
      name: "Full Name",
      selector: (row) => row.FullName,
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.UserName,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.Email,
      cell: (row) => (
        <span>
          {getPermissions?.detailsinfo === 1 ? row.Email : maskEmail(row.Email)}
        </span>
      ),
      sortable: true,
      minWidth: "180px",
    },
    {
      name: "Phone Number",
      selector: (row) => row.PhoneNo,
      cell: (row) => (
        <span>
          {getPermissions?.detailsinfo === 1 ? row.PhoneNo : maskNumber(row.PhoneNo)}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Client Key",
      selector: (row) => row.client_key,
      sortable: true,
      minWidth: "180px",
    },
    {
      name: "Broker",
      selector: (row) => row.broker,
      cell: (row) => showBrokerName(row.broker, row.license_type),
      sortable: true,
    },
    {
      name: "Services",
      selector: (row) => row.licence,
      cell: (row) => (
        <div>{showLicenceName(row.licence, row.license_type)}</div>
      ),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.ActiveStatus,
      omit: isgotodashboard,
      cell: (row) =>
        row.Is_Active === "1" ? (
          <label className="toggle mt-3">
            <input
              className="toggle-checkbox bg-primary"
              type="checkbox"
              checked={row.ActiveStatus === "1"}
              onChange={(e) => activeUser(e, row)}
            />
            <div
              className={`toggle-switch ${row.ActiveStatus === "1" ? "bg-success" : "bg-danger"
                }`}
            ></div>
          </label>
        ) : (
          ""
        ),
    },
    {
      name: "Go To Dashboard",
      selector: () => "",
      width: "150px",
      // omit: !(
      //   getPermissions?.go_To_Dashboard === 1 ||
      //   getPermissions?.go_To_Dashboard === "1"
      // ),
      cell: (row) => (
        <span
          className="btn"
          style={
            row.AppLoginStatus === "0" && row.WebLoginStatus === "0"
              ? { color: "#f5feff",backgroundColor:"#4f46e5"}
              : { color: "#008000",backgroundColor:"#4f46e5" }
          }
          onClick={() => goToDashboard(row._id, row.Email, row)}
          // disabled={row.AppLoginStatus === "0" && row.WebLoginStatus === "0"}
        >
          Dashboard
        </span>
      ),
    },
    {
      name: "TradingStatus",
      selector: (row) => row.TradingStatus,
      cell: (row) => (
        <span
          style={
            row.TradingStatus === "0" || row.TradingStatus === null
              ? { color: "#FF0000", fontSize: "20px" }
              : { color: "#008000", fontSize: "20px" }
          }
        >
          &#9679;
        </span>
      ),
      sortable: true,
    },
    {
      name: "Start Date",
      selector: (row) => row.StartDate,
      cell: (row) =>
        row.StartDate == null ? "----" : fDateTimeSuffix(row.StartDate),
      sortable: true,
      minWidth: "180px",
    },
    {
      name: "End Date",
      selector: (row) => row.EndDate,
      cell: (row) =>
        row.EndDate == null ? "----" : fDateTimeSuffix(row.EndDate),
      sortable: true,
      minWidth: "180px", // ← increase width
    },

    getPermissions?.client_edit === 1  && {
      name: "Actions",
      selector: () => "",
      cell: (row) => (
        <div style={{ width: "120px" }}>
          {isgotodashboard != true ? (
            <Link to={`/subadmin/client/edit/${row._id}`} state={row}>
              <Pencil
                size={20}
                color="#198754"
                strokeWidth={2}
                className="mx-1"
                title="Edit"
              />
            </Link>
          ) : row.Is_Active === "1" || row.Is_Active === 1 ? (
            <>
              {(getPermissions?.client_edit === 1 ||
                (getPermissions?.Update_Api_Key === 1 &&
                  row.license_type !== "1" &&
                  row.Is_Active === "1")) && (
                  <>
                    <Link to={`/subadmin/client/edit/${row._id}`} state={row}>
                      <Pencil
                        size={20}
                        color="#198754"
                        strokeWidth={2}
                        className="mx-1"
                        title="Edit"
                      />
                    </Link>

                    {/* {(row?.license_type === "1" ||
                      row?.license_type === 1) &&
                      getPermissions?.Update_Api_Key === 0 && (
                        <Trash2
                          size={20}
                          color="#d83131"
                          strokeWidth={2}
                          className="mx-1"
                          title="Delete"
                          onClick={() => Delete_user(row._id)}
                        />
                      )} */}
                  </>
                )}
            </>
          ) : null}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];



  const handleTableChange = (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };

  const handleSizePerPageChange = (e) => {
    const value = parseInt(e.target.value);
    setSizePerPage(value);
    setPage(1);
  };

  return (
    <Content
      Page_title="All Clients"
      button_title="Add Client"
      route="/subadmin/client/add"
      button_status={
        getPermissions?.client_add === 1 ||
          getPermissions?.client_add === "1"
          ? true
          : false
      }
    // button_status={admin_permission == 1 ? true : false}/
    >
      <div className="row align-items-end">
        <div className="col-lg-2 col-6">
          <div className="mb-3">
            <label htmlFor="select" className="form-label">
              License Type
            </label>

            <select
              className="default-select wide form-select"
              aria-label="Default select example"
              id="select"
              onChange={(e) => setClientStatus(e.target.value)}
              value={ClientStatus}
            >
              <option value="null">All</option>
              <option value="2">Live</option>
              <option value="1">Demo</option>
              <option value="0">2 Days Only</option>
            </select>
          </div>
        </div>
        <div className="col-lg-2  col-6">
          <div className="mb-3">
            <label htmlFor="select" className="form-label">
              Trading Type
            </label>

            <select
              className="default-select wide form-select"
              aria-label="Default select example"
              id="select"
              onChange={(e) => setPanelStatus(e.target.value)}
              value={PanelStatus}
            >
              <option value="2">All</option>
              <option value="1">On</option>
              <option value="0">Off</option>
            </select>
          </div>
        </div>
        <div className="col-lg-3  col-6">
          <div className="mb-3">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Search Something Here
            </label>
            <input
              type="text"
              placeholder="Search..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)} // Update input on change
              className="form-control"
              id="exampleFormControlInput1"
            />
          </div>
        </div>

        <div className="col-lg-2  col-6">
          <div className="mb-3 mt-sm-3">
            <button onClick={handleSearch} className="btn btn-primary mt-3 me-2">
              Search
            </button>
            <button
              className="btn btn-md btn-primary mt-3 "
              onClick={() => setrefresh((prev) => !prev)}
            >
              <i className="fa fa-refresh"></i>
            </button>
          </div>
        </div>



      </div>

      {isLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "300px" }}
        >
          <Loader />
        </div>
      ) : (
        <Table
          columns={columns}
          data={
            getAllClients?.data?.filter((item) =>
              [item?.FullName, item?.Email, item?.UserName]
                .some((field) =>
                  field?.toLowerCase()?.includes(searchInput.toLowerCase())
                )
            )
          }
        />
      )}

      {/* <ToastButton /> */}
    </Content>
  );
};

export default AllClients;
